<script lang="ts" setup>
import { computed, toRefs } from 'vue';

interface Props {
  name?: string;
  color?: string;
  library?: string;
  size?: string;
}

const props = withDefaults(defineProps<Props>(), {
  name: 'circle',
  color: 'var(--text-color-secondary)',
  library: 'material-icons',
  size: 'md-18',
});

const { name, library, size } = toRefs(props);

const classStyles: string = computed(() => `${library.value} ${size.value} select-none`);
</script>

<template><i :class="classStyles" v-text="name" /></template>
